import { render, staticRenderFns } from "./Base-Text-Area.vue?vue&type=template&id=100f584b&scoped=true&"
import script from "./Base-Text-Area.vue?vue&type=script&lang=js&"
export * from "./Base-Text-Area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f584b",
  null
  
)

export default component.exports